module.exports = __webpack_public_path__ + "img/642-e961e3.png";